import React from "react";
import { FUNCTIONAL_ROLE_COLORS } from "./df-constants";

const PRIORITY_COLOR = {
  low: "#94A3B8",
  normal: "var(--accent-primary)",
  high: "#F59E0B",
  urgent: "#EF4444",
};

export default function TaskCard({ task, onClick, dragging }) {
  const overdue = task.dueDate && new Date(task.dueDate) < new Date() && task.status !== "done";
  const accentColor = PRIORITY_COLOR[task.priority] || "var(--border-strong)";

  return (
    <div
      onClick={onClick}
      onMouseEnter={(e) => { if (!dragging) e.currentTarget.style.boxShadow = "var(--shadow-md)"; }}
      onMouseLeave={(e) => { if (!dragging) e.currentTarget.style.boxShadow = "var(--shadow-sm)"; }}
      style={{
        background: "var(--bg-surface)",
        padding: 12,
        borderRadius: 10,
        borderLeft: `3px solid ${accentColor}`,
        border: "1px solid var(--border-subtle)",
        borderLeftWidth: 3,
        borderLeftColor: accentColor,
        cursor: "pointer",
        transition: "box-shadow 160ms cubic-bezier(0.4,0,0.2,1), transform 160ms cubic-bezier(0.4,0,0.2,1)",
        boxShadow: dragging ? "var(--shadow-lg)" : "var(--shadow-sm)",
        transform: dragging ? "rotate(1deg)" : "none",
      }}
    >
      <div style={{
        fontSize: 13,
        fontWeight: 500,
        color: "var(--text-primary)",
        marginBottom: 8,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        lineHeight: 1.35,
      }}>
        {task.title}
      </div>

      {task.projectId && (
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            padding: "1px 6px",
            fontSize: 10,
            borderRadius: 4,
            color: "white",
            background: task.projectId.color || "#94A3B8",
            marginBottom: 8,
            fontWeight: 500,
          }}
        >
          {task.projectId.name}
        </span>
      )}

      {task.department && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
          <span style={{
            width: 6, height: 6, borderRadius: 9999,
            background: FUNCTIONAL_ROLE_COLORS[task.department],
          }} />
          <span style={{ fontSize: 10, color: "var(--text-tertiary)", fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.05em" }}>
            {task.department.replace("_", " ")}
          </span>
        </div>
      )}

      {task.labels && task.labels.length > 0 && (
        <div style={{ display: "flex", gap: 4, flexWrap: "wrap", marginBottom: 8 }}>
          {task.labels.slice(0, 3).map((l) => (
            <span key={l} style={{
              display: "inline-flex", padding: "1px 6px", fontSize: 10, borderRadius: 4,
              background: "var(--bg-subtle)", color: "var(--text-secondary)",
            }}>{l}</span>
          ))}
        </div>
      )}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 11, color: "var(--text-tertiary)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {task.priority !== "normal" && (
            <span style={{
              padding: "1px 6px",
              borderRadius: 4,
              fontSize: 10,
              fontWeight: 600,
              background: task.priority === "urgent" ? "rgba(239,68,68,0.14)" :
                          task.priority === "high"   ? "rgba(245,158,11,0.14)" :
                                                       "var(--bg-subtle)",
              color: task.priority === "urgent" ? "#B91C1C" :
                     task.priority === "high"   ? "#92400E" :
                                                  "var(--text-secondary)",
            }}>
              {task.priority}
            </span>
          )}
          {task.dueDate && (
            <span
              title={new Date(task.dueDate).toLocaleString()}
              className="tabular"
              style={{
                color: overdue ? "#EF4444" : "var(--text-tertiary)",
                fontWeight: overdue ? 600 : 400,
              }}
            >
              {new Date(task.dueDate).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
            </span>
          )}
          {(task.comments || []).length > 0 && <span>💬 {task.comments.length}</span>}
        </div>
        <div style={{ display: "flex", marginLeft: "auto" }}>
          {(task.assignees || []).slice(0, 3).map((a, idx) => (
            <div
              key={a._id || a}
              title={a.username || ""}
              style={{
                width: 22, height: 22, borderRadius: 9999,
                background: "var(--accent-primary)",
                color: "white",
                fontSize: 10, fontWeight: 600,
                display: "flex", alignItems: "center", justifyContent: "center",
                border: "2px solid var(--bg-surface)",
                marginLeft: idx === 0 ? 0 : -8,
              }}
            >
              {(a.username || "?").charAt(0).toUpperCase()}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
